import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { motion } from 'framer-motion';
import contactImage from '../assets/contactUs/contact.png'; // Add an illustration or abstract contact icon

const ContactUs = () => {
  const [state, handleSubmit] = useForm('mnndepdp');

  if (state.succeeded) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-20 text-center">
        <h2 className="text-3xl font-bold text-green-600 mb-4">Thank you!</h2>
        <p className="text-gray-700 text-lg">Your message has been successfully sent. We'll get back to you soon!</p>
      </div>
    );
  }

  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="max-w-6xl mx-auto px-6 py-16"
    >
      <div className="grid md:grid-cols-2 gap-12 items-center">
        {/* Left: Image or Illustration */}
        <div>
          <img
            src={contactImage}
            alt="Contact Us Illustration"
            className="w-full h-auto rounded-xl shadow-lg"
          />
        </div>

        {/* Right: Form */}
        <div>
          <h1 className="text-4xl font-bold text-blue-600 mb-6">Contact Us</h1>
          <p className="text-gray-700 mb-6 text-lg">
            Have questions, suggestions, or just want to say hello? We’d love to hear from you!
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">Full Name</label>
              <input
                id="name"
                type="text"
                name="name"
                required
                className="mt-1 block w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
              <input
                id="email"
                type="email"
                name="email"
                required
                className="mt-1 block w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <ValidationError prefix="Email" field="email" errors={state.errors} />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700">Your Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                required
                className="mt-1 block w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <ValidationError prefix="Message" field="message" errors={state.errors} />
            </div>

            <button
              type="submit"
              disabled={state.submitting}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md transition duration-200"
            >
              {state.submitting ? 'Submitting...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </motion.section>
  );
};

export default ContactUs;
